import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
// @ts-ignore
import packageJson from '../../package.json'
import tasks from './tasks-module'
import directus from './directus-module'
import unsubscribe from './unsubscribe-module'

Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [createPersistedState({ storage: window.sessionStorage, key: packageJson.name + '-vx' })],
  modules: { tasks, unsubscribe, directus }
})

export default store
